import React from 'react';
import { motion } from 'framer-motion';
export function CreatorSection() {
  return <section className="w-full bg-white py-10 md:py-16 px-6" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-43">
          <h2 className="font-black text-3xl md:text-4xl text-center mb-4 text-[#1a1a2e]" data-id="element-44">
            Who Created This Protocol?
          </h2>
          <p className="text-center text-lg text-gray-500 mb-10" data-id="element-45">
            A father who almost lost everything.
          </p>

          {/* Father & Son Photo */}
          <div className="flex justify-center mb-10" data-id="element-46">
            <div className="w-64 h-64 md:w-72 md:h-72 rounded-full overflow-hidden shadow-2xl border-4 border-[#1a56db]" data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/dJa4tegnZxxxW5VLz5dmaz/eb834a12-d2ef-4c49-874d-f55edaef3421.png" alt="Daniel and his son laughing together" className="w-full h-full object-cover" data-id="element-48" />
            </div>
          </div>

          {/* Story */}
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[#1a1a2e]" data-id="element-49">
            <p data-id="element-50">
              My name is Daniel, and two years ago, I was{' '}
              <span className="font-bold" data-id="element-51">terrified</span> of my own son.
            </p>

            <p data-id="element-52">
              Not because he was dangerous — but because every time I looked
              into his eyes, I saw a stranger. The boy who used to run to me at
              the door, who begged for bedtime stories, who laughed at my
              terrible jokes... he was <span className="font-bold" data-id="element-53">gone</span>.
            </p>

            <p data-id="element-54">
              Replaced by a child who couldn't look up from a screen. Who
              screamed when I set boundaries. Who told me he{' '}
              <span className="font-bold text-red-600" data-id="element-55">"hated me"</span> because
              I turned off the Wi-Fi.
            </p>

            <p data-id="element-56">
              I tried everything. Parenting books. Family therapy. Screen time
              apps. Reward charts.{' '}
              <span className="font-bold" data-id="element-57">Nothing worked.</span>
            </p>

            <p data-id="element-58">
              Until one night, at 2 AM, exhausted and crying in my kitchen, I
              stumbled onto a research paper about{' '}
              <span className="font-bold text-[#1a56db]" data-id="element-59">
                dopamine bridging
              </span>{' '}
              — a neurological technique used in addiction recovery.
            </p>

            <p data-id="element-60">
              That paper changed everything. I spent the next 6 months studying
              the neuroscience of digital addiction in children, consulting with
              child psychologists, and testing a simple protocol on my own
              family.
            </p>

            <div className="bg-blue-50 border-l-4 border-[#1a56db] p-6 rounded-r-xl my-8" data-id="element-61">
              <p className="font-bold text-xl md:text-2xl text-[#1a56db] mb-3" data-id="element-62">
                The result?
              </p>
              <p className="text-lg md:text-xl" data-id="element-63">
                Within <span className="font-bold" data-id="element-64">one week</span>, my son put
                down the tablet on his own for the first time in over a year.
                Within <span className="font-bold" data-id="element-65">one month</span>, we were
                having real conversations again. He started doing homework
                without being asked. He started{' '}
                <span className="font-bold text-[#1a56db]" data-id="element-66">laughing</span>{' '}
                again.
              </p>
            </div>

            <p data-id="element-67">
              I got my son back. And I turned everything I learned into this
              protocol so that{' '}
              <span className="font-bold" data-id="element-68">you can get your child back too</span>
              .
            </p>

            <p className="text-center font-bold text-xl md:text-2xl pt-4 text-[#1a1a2e]" data-id="element-69">
              This isn't theory. This is a father's desperate fight — turned
              into your shortcut.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}